import initTranslations from "app/i18n"

export const clientTextTranslator = async (lang: string, text: string): Promise<string> => {
    const { t } = await initTranslations(lang)
    return t(text)
}